
import { timeout } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { ConfigService } from '../shared/config/config.service';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../shared';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'login',
  template: `
    <ngx-spinner
      bdColor="rgba(51,51,51,0.8)"
      size="medium"
      color="#fff"
      type="line-spin-clockwise-fade">
      <p style="font-size: 20px; padding-top:10px; color: white">Loading...</p>
    </ngx-spinner>
    `,
  standalone: false
})
export class LoginComponent implements OnInit {
  private returnUrl: string;

  // Add arpUsap and arpOrigin for endpoint logic
  // These should be set from query params if present
  private arpUsap: string;
  private arpOrigin: string;
  constructor(
    private logger: NGXLogger,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private config: ConfigService,
    private spinner: NgxSpinnerService,
    private location: Location,
    private http: HttpClient
  ) {
  }

  public ngOnInit() {
    this.logger.log('Login Component:');
    this.logger.log('Loading LoginComponent');

    // subscribe to router event
    this.logger.log('[LoginComponent] getEnv:', this.config?.getEnv?.());
    this.logger.log('[LoginComponent] getConfig(clp):', this.config?.getConfig?.('clp'));
    this.activatedRoute?.queryParams?.subscribe?.((params: Params) => {
      let accessToken = params?.['access_token'];
      // Set arpUsap and arpOrigin if present
      if (params?.['arp_usap']) {
        this.arpUsap = params['arp_usap'];
        this.config.arpUsap = params['arp_usap'];
        this.logger.log('arp_usap is ', params['arp_usap']);
      }
      if (params?.['arp_origin']) {
        this.arpOrigin = params['arp_origin'];
        this.config.arpOrigin = params['arp_origin'];
        this.logger.log('Arp Origin', this.config.arpOrigin);
      }
      this.returnUrl = '/home';
      if (!accessToken) {
        this.logger.log('[LoginComponent] No accessToken, will redirect to CLP');
        sessionStorage?.clear?.();
        let redirectUri: string = location?.protocol +
          '//' +
          location?.hostname +
          (location?.port ? ':' + location?.port : '') +
          '/#/login?state=' +
          this.returnUrl;

        redirectUri = encodeURIComponent(redirectUri);
        let env = this.config?.getEnv?.();
        let clp = this.config?.getConfig?.('clp');
        if (env === 'prd') {
          env = 'www';
        }
        if (clp?.url) {
          this.logger.log('[LoginComponent] Redirecting to CLP:', clp.url);
          const clpURL = clp.url.replace(/{ENV}/, env?.toLowerCase?.());
          window.location.href = clpURL + redirectUri;
        } else {
          this.logger.error('[LoginComponent] CLP config or clp.url is undefined! Cannot redirect to login. clp:', clp);
        }
      } else {
        sessionStorage?.setItem?.('access_token', accessToken);
        this.spinner.show();
        this.getUserProfile?.().then?.((profile: ProfileDetail) => {
          sessionStorage?.setItem?.('user', JSON.stringify(profile));
          this.spinner.hide();
          this.config?.isLoggedIn?.(true);
          this.router?.navigate?.(['/home']);
          this.location?.replaceState?.('/');
        }, (error) => {
          this.spinner.hide();
          this.config?.isLoggedIn?.(true);
          let userData = {
            userDetails: {
              userId: '',
              organization: '',
              officeId: '',
              phase: 'Not Known'
            }
          };
          sessionStorage?.setItem?.('user', JSON.stringify(userData));
          this.router?.navigateByUrl?.('/home');
          this.location?.replaceState?.('/');
          this.logger.error('error in fetching user details');
        });
      }
    });
    this.logger.log('End Login Component');
  }

  private getUserProfile() {
    return new Promise((resolve, reject) => {
      this.http.get(this.getURi())
        .pipe(timeout(59000))
        .toPromise()
        .then(
          (response: ProfileDetail) => {
            // Map all security fields as in Angular 6
            response.security.officeTab = (response.security.officeTab === 'Y');
            response.security.terminalAndPrinterTab = (response.security.terminalAndPrinterTab === 'Y');
            response.security.configurationTab = (response.security.configurationTab === 'Y');
            response.security.vendorSettingTab = (response.security.vendorSettingTab === 'Y');
            response.security.systemDataTab = (response.security.systemDataTab === 'Y');
            response.security.createOffice = (response.security.createOffice === 'Y');
            response.security.restoreOffice = (response.security.restoreOffice === 'Y');
            response.security.historyTab = (response.security.historyTab === 'Y');
            response.security.ctsmigration = (response.security.ctsmigration === 'Y');
            response.security.massiveTabVisible = (response.security.massiveTabVisible === 'Y');
            response.security.massDeviceTabVisible = (response.security.massDeviceTabVisible === 'Y');
            response.security.updateChannelAllowed = (response.security.updateChannelAllowed === 'Y');
            response.security.activationAllowed = (response.security.activationAllowed ? response.security.activationAllowed.split("|") : "");
            resolve(response);
          },
          (error) => {
            reject('error');
          }
        );
    });
  }

  public getAPIEndPoint(arpUsap: string, aomEndPoint: string) {
    return (arpUsap ? (this.config.arpOrigin + '/') : aomEndPoint);
  }

  public getARPEndPoint() {
    if (window.parent.location) {
      console.log('window parent location');
      console.log(window.parent.location);
      let location = window.parent.location.toString();
      const chunks = location.split('/');
      if (chunks.length > 3) {
        return (chunks[0] + '//' + chunks[1] + chunks[2]);
      }
    }
  }

  private getURi(isDraft: boolean = false): string {
    const officeConfigData = this.config.getConfig('office');
    let url = this.getAPIEndPoint(this.config.arpUsap, officeConfigData.apiEndPoint) + (this.config.arpUsap ? this.config.arpUsap : this.config.getOffUsap()) + '/v1/home_page_security';
    this.logger.log(url);
    return url;
  }
}



export interface ProfileDetail {
  security: {
    officeTab: any,
    terminalAndPrinterTab: any,
    vendorSettingTab: any,
    systemDataTab: any,
    createOffice: any,
    restoreOffice: any,
    historyTab: any,
    ctsmigration: any,
    massiveTabVisible: any,
    massDeviceTabVisible: any,
    configurationTab: any;
    updateChannelAllowed: any;
    activationAllowed: any;
  };
  vendorDataGranted: any[];
  orgDataGranted: any[];
  userOfficeDetails: {
    UVC: '',
    airlineCode: ''
  };
}